import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'

let Goback = (props) =>{
  const {url,children,className,onClick,isButton} = props
  const renderMain = () =>{
    const renderChildren = () => {
      return (
        <>
            {!isButton?<i className={'of-gobackstep__icon icon-of-arrow'}/>:<></>}
            <span className={'of-gobackstep__text'}>{children}</span>
            {isButton?<i className={'of-gobackstep__close-icon icon-of-blog-close'}/>:<></>}
        </>
      )
    }
    if(onClick){
      return (
        <div className={`of-gobackstep__link ${isButton?' of-gobackstep__link--button text-font-3-100 lines-border-1-100':' primary-font-1-100'}`} onClick={onClick}>
          {renderChildren()}
        </div>
      )
    }
    return (
      <Link className={`of-gobackstep__link${isButton?' of-gobackstep__link--button text-font-3-100 lines-border-1-100':' primary-font-1-100'}`} to={url}>
        {renderChildren()}
      </Link>
    )
  }

  return (
    <div className={`of-gobackstep${className?' '+className:''}`}>
      {renderMain()}
    </div>
  )
}

Goback.propTypes = {
  url: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
  onClick: PropTypes.func,
  isButton: PropTypes.bool
}

export default Goback